import { render, staticRenderFns } from "./AdminUsers.vue?vue&type=template&id=960a97fe&scoped=true"
import script from "./AdminUsers.vue?vue&type=script&lang=js"
export * from "./AdminUsers.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "960a97fe",
  null
  
)

export default component.exports